declare const sjcl: any;
declare var jQuery: any;

export class EncryptionUtil {

    private static getOptions() {
        return {
            iter: 1000,
            ks: 128,
            ts: 64,
            iv: sjcl.codec.base64.toBits("5olvvndy2od23jThveFRyw=="),
            salt: sjcl.codec.base64.toBits("parYv9E1LYM=")
        };
    }

    static encryptMe =  (password: string | null, message: string) => {
        //Encrypt
        const options = this.getOptions();
        const encrypted = sjcl.encrypt(password ?? '', message, options) as unknown as string;
        // Return only the ciphertext (ct) as string, matching previous behavior
        return JSON.parse(encrypted).ct;
    }

    static decryptMe =  (password: string | null, encMessage: string) => {
        //Decrypt
        const options = this.getOptions();
        const data = { 
            v: 1, 
            mode: "ccm", 
            adata: "", 
            cipher: "aes", 
            ct: encMessage,
            iter: options.iter,
            ks: options.ks,
            ts: options.ts,
            iv: sjcl.codec.base64.fromBits(options.iv),
            salt: sjcl.codec.base64.fromBits(options.salt)
        };
        return sjcl.decrypt(password ?? '', JSON.stringify(data));
    }

    static encrypt(passphrase: string | null, plaintext: string) {
        return this.encryptMe(passphrase, plaintext);
    }

    static decrypt(passphrase: string | null, encText: string) {
        return this.decryptMe(passphrase, encText);
    }

    static encryptDefault(default_key: string, plaintext: string) {
        return this.encryptMe(default_key, plaintext);;
    }

    static decryptDefault(default_key: string, encText: string) {
        return this.decryptMe(default_key, encText);
    }

}